import { FilterUploadHistory, TableHeadCellNamesInterface } from '../../../../interfaces/interfaces';

const tableHeadCellNames: TableHeadCellNamesInterface = {
  uploadedOn: 'Uploaded on',
  uploadedBy: 'Uploaded by',
  fileType: 'File Type',
  fileContent: 'File Content',
  fileSource: 'File Source',
  version: 'Version',
  fileLastUpdated: 'File Last Updated',
  fileName: 'File Name',
  uploadStatus: 'Upload Status',
  uploadReport: 'Upload Report',
};

export const filterUploadHistoryKeys: (keyof FilterUploadHistory)[] = [
  'uploadedOn',
  'uploadedBy',
  'fileType',
  'fileContent',
  'fileSource',
  'version',
  'fileLastUpdated',
  'fileName',
  'uploadStatus',
];

export default tableHeadCellNames;
